<template>
  <div class="row col-hspace form-classic">
    <div class="col-xs-12 col-vbspace">
      <div class="col-xs-12">
        <select
          v-model="selectMessage"
          id="asking-choice"
          name="asking-choice"
          class="classic-select--v2 tcenter"
        >
          <option value="">CHOISISSEZ ICI ...</option>
          <option
            v-for="(option, index) in options"
            :value="option.value"
            :key="index"
          >
            {{ option.value }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: 'Coucou',
    },
    options: {
      type: Array,
      default: () => [{ value: 'coucou' }, { value: 'hello' }, { value: 'ciao' }],
    },
  },

  data() {
    return {
      maxLength: 20,
      active: 'list',
      default: '',
      selectMessage: '',
    };
  },

  created() {
    this.default = this.message;
  },

  watch: {
    selectMessage() {
      this.changeName();
    },

    active() {
      this.$emit(
        'change-name',
        this.active === 'list' ? this.selectMessage : this.innerMessage,
      );
    },
  },

  computed: {
    innerMessage: {
      get() {
        return this.message;
      },
      set(newValue) {
        this.$emit('change-name', newValue.toUpperCase());
      },
    },
  },

  methods: {
    resetName() {
      if (this.message === this.default) {
        this.$emit('change-name', '');
      }
    },

    backName() {
      if (this.message === '') {
        this.$emit('change-name', this.default);
      }
    },

    changeName() {
      this.default = this.selectMessage;
      this.$emit('change-name', this.selectMessage);
    },

    focusInput() {
      this.active = 'own';
      this.resetName();
    },

    focusSelect() {
      this.active = 'list';
    },
  },
};
</script>
